import React, { useEffect, useState } from "react";
import { TOP_SELLING_PERIODS } from "../../constants/Common";
import dayjs from "dayjs";
import { getTopSellingItems } from "../../services/dashboardService";

const TopSellingProduct = () => {
  const [selectedPeriod, setSelectedPeriod] = useState("thisweek");
  const [topSellingProductsData, setTopSellingProductsData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handlePeriodChange = (event) => {
    setSelectedPeriod(event.target.value);
  };

  // Get products based on the selected period
  // const filteredProducts = topSellingProductsData[selectedPeriod] || [];

  const getDefaultDateRange = (tab) => {
    const today = dayjs();
    let fromDate;
    if (tab === "thisweek") fromDate = today.subtract(7, "day");
    else if (tab === "thismonth") fromDate = today.subtract(1, "month");
    else fromDate = today.subtract(1, "year");

    return {
      fromDate: fromDate.format("YYYY-MM-DD"),
      toDate: today.format("YYYY-MM-DD"),
    };
  };

  const fetchSalesData = async (fromDate, toDate) => {
    setLoading(true);
    try {
      const response = await getTopSellingItems({
        category: "sales tracking",
        start_date: fromDate,
        end_date: toDate,
      });

      if (response?.data) {
        // const mapped = response.data.response_data.map((item) => ({
        //   name: item.product_group,
        //   sales: item.Sale_Count,
        // }));
        setTopSellingProductsData(response.data);
      }
    } catch (err) {
      console.error("Failed to fetch data", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let fromDate = getDefaultDateRange(selectedPeriod).fromDate;
    let toDate = getDefaultDateRange(selectedPeriod).toDate;

    // if (!fromDate || !toDate) {
    //   const defaultRange = getDefaultDateRange(activeTab);
    //   fromDate = defaultRange.fromDate;
    //   toDate = defaultRange.toDate;
    //   setDateRange(defaultRange);
    //   setDisplayDateRange(`${formatDate(fromDate)} - ${formatDate(toDate)}`);
    // }

    fetchSalesData(fromDate, toDate);
  }, [selectedPeriod]);

  return (
    <div className="p-5 border border-gray-300 rounded-lg min-h-[600px]">
      <div className="flex justify-between items-center gap-2">
        <h2 className="text-lg font-semibold text-text1">
          Top Selling Product Groups
        </h2>
        <div className="flex gap-3">
          <div className="primary-dropdown">
            <select
              name="timePeriod"
              className="rounded px-1 text-sm font-normal text-text1 focus:outline-none focus:ring-0 w-full cursor-pointer "
              onChange={handlePeriodChange}
              value={selectedPeriod}
            >
              {TOP_SELLING_PERIODS.map(({ key, label }) => (
                <option key={key} value={key}>
                  {label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="mt-6">
        {topSellingProductsData.length > 0 ? (
          topSellingProductsData.map((product) => (
            <div key={product._id} className="flex items-center gap-6 pb-6">
              <div className="flex flex-col justify-center flex-grow">
                <h3 className="font-normal text-text2 text-base">
                  {product.product_group}
                </h3>
                <p className="text-text3 text-sm font-medium">
                  Unit sold: {product.Total_Count / 1000} K
                </p>
              </div>
              <div className="text-right">
                <p className="text-base font-semibold">
                  ₹{product.Total_revenue.toFixed(2)}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="border rounded-md border-gray-200 p-4 text-center">
            {loading ? "Data Loading..." : "No data available"}
          </div>
        )}
      </div>
    </div>
  );
};

export default TopSellingProduct;
